import config from '../../config'
import fetch from '../../lib/wrappedFetch'

class MessageService {
  getMessagePreview = (id, variables) => {
    return fetch(config.config.endpointUrls.getCustomerMessagePreview(id), {
      method: 'POST',
      body: variables,
      responseType: 'text'
    })
  }
  sendMessage = (fields) => {
    return fetch(config.config.endpointUrls.sendMessage(), {
      method: 'POST',
      body: fields
    })
  }
  fetchMessages = (params) => {
    return fetch(config.config.endpointUrls.fetchMessages(params), {
      method: 'GET'
    })
  }
  fetchMessagesByCustomerIdPaged = (params) => {
    return fetch(config.config.endpointUrls.fetchMessagesByCustomerIdPaged(params), {
      method: 'GET'
    })
  }
  fetchMessageTemplates = (query) => {
    return fetch(config.config.endpointUrls.fetchMessageTemplates(query), {
      method: 'GET'
    })
  }
  flagMessage = (params) => {
    return fetch(config.config.endpointUrls.flagMessage(params), {
      method: 'POST'
    })
  }
  fetchMessageById = (id, query) => {
    return fetch(config.config.endpointUrls.fetchMessageById(id, query), {
      method: 'GET'
    })
  }

  searchMessages = (params) => {
    return fetch(config.config.endpointUrls.searchMessages(), {
      method: 'POST',
      body: params
    })
  }
}

export default new MessageService()


// WEBPACK FOOTER //
// ../src/services/messageService/messageService.js